var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationEmptyStateWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 50.14,
    y: 29.59,
    width: 23.82,
    height: 29.77,
    transform: "translate(6.79 97.16) rotate(-79.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.85,59.54l-30.23-5.73,4.62-24.38,30.23,5.73-4.62,24.38Zm-29.06-6.53l28.27,5.36,4.25-22.42-28.27-5.36-4.25,22.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.42,64.25l-.55,2.92c-.61,3.22-3.74,5.35-6.96,4.74l-40.95-7.76c-3.25-.62-5.35-3.74-4.74-6.96l7.76-40.95c.61-3.22,3.71-5.36,6.96-4.74l40.95,7.76c3.22,.61,5.35,3.74,4.74,6.96l-.55,2.92-26.32-4.99c-3.25-.62-6.35,1.52-6.96,4.74l-4.44,23.4c-.61,3.22,1.49,6.34,4.74,6.96l26.32,4.99Zm-12.13-15.93c-2.43-.46-4.02-2.79-3.56-5.22s2.79-4.02,5.22-3.56,4.02,2.79,3.56,5.22c-.46,2.43-2.79,4.02-5.22,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.02,72.52c-.4,0-.8-.04-1.2-.11l-40.95-7.76c-3.5-.66-5.8-4.05-5.14-7.54l7.76-40.95c.32-1.69,1.28-3.16,2.7-4.13,1.42-.97,3.15-1.33,4.84-1.01l40.95,7.76c1.69,.32,3.15,1.28,4.13,2.71,.97,1.43,1.33,3.14,1.01,4.83l-.65,3.42-26.81-5.08c-2.96-.56-5.81,1.39-6.38,4.34l-4.43,23.4c-.27,1.43,.03,2.88,.85,4.08,.82,1.21,2.06,2.02,3.5,2.29l26.82,5.08-.65,3.42c-.32,1.69-1.28,3.15-2.71,4.13-1.09,.74-2.34,1.13-3.63,1.13ZM30.81,11.9c-1.09,0-2.15,.33-3.06,.95-1.2,.82-2.01,2.06-2.28,3.49l-7.76,40.95c-.56,2.96,1.39,5.82,4.34,6.38l40.95,7.76c1.42,.27,2.88-.04,4.08-.86,1.21-.82,2.02-2.06,2.29-3.49l.46-2.43-25.83-4.9c-1.7-.32-3.17-1.29-4.14-2.71-.97-1.42-1.32-3.14-1-4.83l4.43-23.4c.66-3.5,4.05-5.81,7.54-5.14l25.83,4.9,.46-2.43c.27-1.42-.03-2.88-.86-4.08-.82-1.21-2.06-2.02-3.49-2.29L31.84,11.99c-.34-.07-.69-.1-1.03-.1Zm28.32,37c-.31,0-.63-.03-.94-.09-2.69-.51-4.46-3.11-3.95-5.8,.25-1.31,.99-2.44,2.08-3.18,1.1-.75,2.42-1.02,3.72-.77,1.3,.25,2.43,.99,3.18,2.08,.75,1.09,1.02,2.42,.77,3.72-.25,1.31-.99,2.44-2.08,3.18-.83,.57-1.8,.86-2.78,.86Zm-.03-8.93c-.79,0-1.56,.24-2.22,.69-.87,.6-1.46,1.5-1.66,2.54s.02,2.1,.62,2.97c.59,.87,1.5,1.46,2.54,1.66,2.15,.41,4.23-1.01,4.63-3.16,.2-1.04-.02-2.1-.62-2.97-.59-.87-1.5-1.46-2.54-1.66-.25-.05-.5-.07-.75-.07Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateWallet);
export default __webpack_public_path__ + "static/media/illustration_empty-state-wallet.409931fa2036f71561adf7ef0e06bd5a.svg";
export { ForwardRef as ReactComponent };